import { REMOVE_NOTIFICATION } from 'actions';

export default function removeNotification(notification) {
  return {
    type: REMOVE_NOTIFICATION,
    payload: notification,
  };
}
